const INVALID_JSON = 'invalid-json';
const PRE_AUTH_CONFIG_QUERY_NAME = 'preAuthConfig';
const RECORD_NOT_FOUND_MESSAGE = 'RecordNotFound';

const isAccessDeniedError = (error) => {
  return error.graphQLErrors?.some(({ path, extensions, message }) => {
    // specific conditions for the first GraphQL query that happens
    if (path?.includes(PRE_AUTH_CONFIG_QUERY_NAME)) {
      return message.includes(RECORD_NOT_FOUND_MESSAGE) || extensions?.exception?.type === INVALID_JSON;
    }
  });
};

export default isAccessDeniedError;
